<template>
    <user :id="$store.state.user.currentUser.id"></user>
</template>

<script>
  import User from "./User";

  export default {
      components:{
          User
      }
  }
</script>
